const API_BASE_URL = process.env.REACT_APP_RECRUIT_API_URL || 'http://localhost:8080';

async function request(path, options = {}) {
    const res = await fetch(`${API_BASE_URL}${path}`, {
        ...options,
        headers: { 'Content-Type': 'application/json', ...options.headers },
    });
    if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        const error = new Error(body.message || '요청에 실패했습니다.');
        error.status = res.status;
        throw error;
    }
    const text = await res.text();
    if (!text) return null;
    return JSON.parse(text);
}

export const authRepository = {
    register: (data) =>
        request('/api/auth/register', { method: 'POST', body: JSON.stringify(data) }),

    // COMPANY 가입 전용 — 담당자 실물 명함 사진을 같은 요청에 함께 보낸다. multipart라
    // request() 헬퍼(JSON Content-Type 고정)를 쓰지 않고 직접 fetch한다. 가입 완료 전엔
    // company.id가 없어 계정별 S3 경로를 쓸 수 없었는데, 백엔드가 가입 처리 도중 PK를 확보한 뒤
    // 그 경로로 업로드하도록 바뀌면서 사전 업로드 없이 한 번에 보내는 방식으로 변경됨 (2026-09-04).
    registerCompany: async (data, nameCardFile) => {
        const formData = new FormData();
        formData.append('data', new Blob([JSON.stringify(data)], { type: 'application/json' }));
        formData.append('nameCard', nameCardFile);
        const res = await fetch(`${API_BASE_URL}/api/auth/register`, {
            method: 'POST',
            body: formData,
        });
        if (!res.ok) {
            const body = await res.json().catch(() => ({}));
            const error = new Error(body.message || '요청에 실패했습니다.');
            error.status = res.status;
            throw error;
        }
    },

    checkEmail: (email) =>
        request(`/api/auth/check-email?email=${encodeURIComponent(email)}`),

    login: (data) =>
        request('/api/auth/login', { method: 'POST', body: JSON.stringify(data) }),

    verifyEmail: (token) =>
        request(`/api/auth/verify-email?token=${token}`),

    refresh: (refreshToken) =>
        request('/api/auth/refresh', { method: 'POST', body: JSON.stringify({ refreshToken }) }),

    logout: (refreshToken) =>
        request('/api/auth/logout', { method: 'POST', body: JSON.stringify({ refreshToken }) }),

    requestPasswordReset: (email) =>
        request(`/api/auth/password-reset/request?email=${encodeURIComponent(email)}`, { method: 'POST' }),

    confirmPasswordReset: (data) =>
        request('/api/auth/password-reset/confirm', { method: 'POST', body: JSON.stringify(data) }),

    getMe: (accessToken) =>
        request('/api/auth/me', { headers: { Authorization: `Bearer ${accessToken}` } }),

    withdraw: (accessToken, password) =>
        request('/api/auth/me', {
            method: 'DELETE',
            headers: { Authorization: `Bearer ${accessToken}` },
            body: password != null ? JSON.stringify({ password }) : undefined,
        }),
};

export const otpRepository = {
    request: (target, type) =>
        request('/api/auth/otp/request', { method: 'POST', body: JSON.stringify({ target, type }) }),

    check: (target, type, code) =>
        request('/api/auth/otp/check', { method: 'POST', body: JSON.stringify({ target, type, code }) }),
};

export const companyRepository = {
    getProfile: (accessToken) =>
        request('/api/company/profile', { headers: { Authorization: `Bearer ${accessToken}` } }),

    updateProfile: (accessToken, data) =>
        request('/api/company/profile', {
            method: 'PUT',
            headers: { Authorization: `Bearer ${accessToken}` },
            body: JSON.stringify(data),
        }),
};
